import { http } from '../http/api'

export default {
  // 搜索商品的列表
  async searchGoodsAction ({ commit }, keyword) {
    var res = await http.post('/index.php?r=api/index', {keyword})
    commit('SEARCH_GOODS_LIST', res.commoditys)
    return res.commoditys // 给返回是Promise对象相当于 resolve(res)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js